import React, { useState } from "react"
import { Offer } from "../../../offers/list/types"
import { AuthUser } from "../../../auth/types"
import { sendReceiptToEmail } from "../../../offers/list/actions"
import { Button, notification } from "antd"

interface Props {
  offer: Offer
  user: AuthUser
  isSeller: boolean
}

export const SendReceiptToCurrentUserEmail = (props: Props) => {
  const [isPdfLoading, setIsPdfLoading] = useState(false)

  const notificationMsg = props.isSeller
    ? `Doer receipt sent to ${props.user.email}`
    : `Customer receipt sent to ${props.user.email}`

  const btnText = props.isSeller
    ? `Send doer receipt to ${props.user.email}`
    : `Send customer receipt to ${props.user.email}`

  const sendEmail = async () => {
    try {
      setIsPdfLoading(true)
      const result = await sendReceiptToEmail(props.user.email, "receipt", {
        offerId: props.offer.id,
        isSeller: props.isSeller,
      })
      result
        ? notification.success({
            message: notificationMsg,
            duration: 3,
          })
        : notification.success({
            message: "Error sending receipt",
            duration: 3,
          })
    } catch (error) {
      notification.success({
        message: "Something went wrong",
        duration: 3,
      })
    } finally {
      setIsPdfLoading(false)
    }
  }

  return (
    <Button
      type="primary"
      size="large"
      disabled={isPdfLoading}
      onClick={sendEmail}
    >
      {isPdfLoading ? "Loading..." : btnText}
    </Button>
  )
}
